export const formatObject = (params, replaceKeyValue) => {
  let result = {}
  for (let i in params) {
    let kvs = replaceKeyValue(i, params[i])
    // 手动设置return null等于删除key
    if (typeof kvs === 'undefined') {
      kvs = { key: i, value: params[i] }
    }
    let kvArray = []
    if (kvs instanceof Array) {
      kvArray = kvs
    } else {
      kvArray = [kvs]
    }
    kvArray.map((kv) => {
      if (kv && kv && 'key' in kv && 'value' in kv) {
        result[kv.key] = kv.value
      }
    })
  }
  return result
}
export const toCurrency = (number, symbol, places, thousand, decimal) => {
  number = number || 0
  places = !isNaN((places = Math.abs(places))) ? places : 2
  symbol = symbol !== undefined ? symbol : ''
  thousand = thousand || ','
  decimal = decimal || '.'
  let negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
    j = i.length
  j = j > 3 ? j % 3 : 0
  return (
    symbol +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : '')
  )
}
export const toChineseCapitalCurrency = (n) => {
  var fraction = ['角', '分']
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ]
  var head = n < 0 ? '欠' : ''
  n = Math.abs(n)

  var s = ''

  for (var i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)

  for (var i = 0; i < unit[0].length && n > 0; i++) {
    var p = ''
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  )
}
export const toChinseDigit = (n) => {
  var digit = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const numStr = String(toNumber(n))
  let s = ''
  for (let i = 0; i < numStr.length; i++) {
    s += digit[numStr[i]]
  }
  return s
}
export const toNumber = (v, maxDemical = 2) => {
  // 将 金额/类金额/数字转换 成 数字（最多2位小数）;
  if (v) {
    let s = String(v)
    let num = Number(s.replace(/[^(\d||/.)]/g, ''))
    // 处理负数
    if (s.charAt(0) === '-') {
      num = -num
    }
    if (isNaN(num)) {
      return 0
    } else {
      return Number(num.toFixed(maxDemical))
    }
  } else {
    return 0
  }
}
export const toHttps = (v) => {
  if (v) {
    return v.replace('http://', 'https://')
  }
  return ''
}
